import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';

@Injectable()
export class NeoComunService {
  public url: String;

  constructor(private _http: HttpClient) {
    this.url = environment.apiLocalUrl + 'comun/servicios';
  }

  getDetalleSolicitud(datosDetalleSolicitud: Record<string, unknown>) {
    let body = JSON.stringify(datosDetalleSolicitud);
    let headers = new HttpHeaders().set('Content-type', 'application/json');

    return this._http.post(this.url + '/detallesSolicitud', body, {
      headers: headers,
    }).pipe(catchError(HandleHttpError));
  }

  refreshToken(token: string) {
    return this._http.post(`${this.url}/restablecerToken`, { token }).pipe(catchError(HandleHttpError));
  }

  isAccessByRol(pagina: string) {
    return this._http.post(`${this.url}/validarAccesoPagina`, { pagina }).pipe(catchError(HandleHttpError));
  }

  enviarCorreo(body: any) {
    return this._http.post(`${this.url}/ayudaActivacionCuenta`, body).pipe(catchError(HandleHttpError));
  }
}